<template>
    <b-card class="pr-2 pl-2">
        <Loader loader v-if="isLoading" />
        <div v-else>
            <NBoxesSelect
                :nBoxes="nBoxes"
                :hasNBoxes="hasNBoxes"
                :selected="selectedNBoxes"
                @change="setSelectedNBoxes"
                @create-n-box="onClickCreateNBox"
            />
            <div
                :key="nBoxId"
                :id="`n-box-${nBoxId}`"
                class="n-box-container"
                v-for="(nBoxId, index) in selectedNBoxes"
            >
                <NBox :nBoxId="nBoxId" @ready="onLoadNBox(nBoxId, index)" />
            </div>
        </div>
        <div
            class="d-flex flex-column align-items-center p-3"
            v-if="!selectedNBoxes.length && !isLoading"
        >
            <h4 class="text-muted mb-3">{{ $t('nBox.noNBoxSelected') }}</h4>
            <b-button
                id="btn-nbox-reports-new"
                class="mb-1"
                size="md"
                variant="primary"
                @click="onClickCreateNBox"
                >{{ $t('nBox.createNewNBox') }}</b-button
            >
            <b-button
                id="btn-nbox-reports-go-to-nbox-list"
                size="sm"
                variant="link"
                @click="onClickGoToNBoxList"
                class="text-muted mb-4"
            >
                {{ $t('nBox.goToNBoxList') }}
            </b-button>
            <img class="cards" src="@/assets/images/cards.svg" />
        </div>
    </b-card>
</template>
<script>
import Aside from '@/shared/aside'
import { difference } from 'lodash'
import Loader from '@/views/components/loader'
import { NBox, NBoxesSelect } from './components'
import { mapActions, mapState, mapGetters } from 'vuex'

const VUEX_MODULE_NAME = 'nBoxesReport'

export default {
    components: {
        NBox,
        Loader,
        NBoxesSelect,
    },
    data() {
        return {
            lastSelectedNBoxId: null,
        }
    },
    computed: {
        ...mapState(VUEX_MODULE_NAME, [
            'slider',
            'nBoxes',
            'isLoading',
            'selectedNBoxes',
        ]),
        ...mapGetters(VUEX_MODULE_NAME, ['hasNBoxes']),
    },
    watch: {
        selectedNBoxes(newValue, oldValue) {
            const newValueLength = Object.keys(newValue).length
            const oldValueLength = Object.keys(oldValue).length

            if (newValueLength > oldValueLength) {
                const nBoxId = difference(newValue, oldValue)[0]
                this.lastSelectedNBoxId = nBoxId
                this.updateNBoxLoader({ nBoxId, isLoading: true })
            }
        },
    },
    created() {
        this.getNBoxes()
    },
    destroyed() {
        this.closeSlider()
        this.resetData()
    },
    methods: {
        ...mapActions(VUEX_MODULE_NAME, [
            'resetData',
            'getNBoxes',
            'updateNBoxLoader',
            'setSelectedNBoxes',
        ]),
        onLoadNBox(nBoxId, index) {
            this.updateNBoxLoader({ nBoxId, isLoading: false })
            if (index > 0 && nBoxId == this.lastSelectedNBoxId) {
                this.scrollToNBox(nBoxId)
            }
        },
        scrollToNBox(id) {
            this.$scrollTo(`#n-box-${id}`)
        },
        onClickCreateNBox() {
            this.$router.push('/v2/n-box/new')
        },
        onClickGoToNBoxList() {
            this.$router.push('/v2/n-box/list')
        },
        closeSlider() {
            if (this.slider.isOpen) {
                Aside.close()
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.n-box-container {
    padding: 20px;
    position: relative;
    border-radius: 6px;
    margin-bottom: 32px;
    box-shadow: 1px 2px #ebebeb;
    border-right: 1px solid #c8ced3;
    border-bottom: 1px solid #c8ced3;

    &::before {
        content: '';
        display: block;
        position: absolute;
        height: calc(100% - 2px);
        top: 50%;
        left: 1px;
        width: 4px;
        border-radius: 6px;
        transform: translateY(-50%);
        background-color: #009bdb;
    }
}

.cards {
    max-width: 600px;
    max-height: 800px;
}
</style>
